<!--
 * @Author: yindengli
 * @Date: 2023-06-27 14:09:54
 * @LastEditTime: 2023-07-05 11:20:06
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\updateLog\updateLog.vue
-->
<template>
  <div class="updatelog">
    <div v-if="logsTitle.length && curLog" class="log-content">
      <mavon-editor class="content" :toolbarsFlag="false" defaultOpen="preview" :value="curLog.content"
        :subfield="false" :boxShadow="false" :ishljs="true" :externalLink="externalLink" previewBackground="none" />
    </div>
    <div class="no-log" v-else>
      <span class="no-log-info">暂无更新日志</span>
    </div>
  </div>
</template>
<script>

import request from '../../utils/request';
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";

export default {
  components: {
    mavonEditor
  },
  data() {
    return {
      logsTitle: [],
      curLogId: '', // 当前展示log id
      curLog: null, // 当前显示log
      unfold: true, // 展开
      windowWidth: 1920, // 默认窗口大小为1920px

      externalLink: {
        markdown_css: function () {
          // 这是markdown css文件路径
          return '/cdn-lib/markdownCss/github-markdown.min.css'
        },
        hljs_js: function () {
          // 这是hljs文件路径
          return '/cdn-lib/highlight/highlight.min.js'
        },
        katex_css: function () {
          // 这是katex配色方案路径路径
          return '/cdn-lib/KaTex/katex.min.css'
        },
        katex_js: function () {
          // 这是katex.js路径
          return '/cdn-lib/KaTex/katex.min.js'
        },
        hljs_css: function (css) {
          // 这是你的代码高亮配色文件路径
          return '/cdn-lib/highlight/styles/' + css + '.min.css';
        },
        hljs_lang: function (lang) {
          // 这是你的代码高亮语言解析路径
          return '/cdn-lib/highlight/languages/' + lang + '.min.js';
        },
      }
    }
  },
  computed: {
    left() {
      let className = 'left';
      if (this.windowWidth > 1024) {
        className = "left";
      } else if (this.unfold) {
        className = "left-min hide";

      } else {
        className = "left-min";
      }
      return className;
    }
  },
  created() {
    this.getOutlineLogs();
    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", this.watchWindowSize);
  },
  methods: {
    watchWindowSize() {
      this.windowWidth = window.innerWidth;
    },
    // 获取所有的日志大纲
    getOutlineLogs() {
      request({
        url: "/faq/faq/v1/getUpdateContentLogTitle",
        method: 'get'
      }).then(res => {
        if (res && res.data && res.data.updateLogTitles && res.data.updateLogTitles.length > 0) {
          this.logsTitle = res.data.updateLogTitles;

          // 默认获取第一个日志信息
          this.getLogItem(this.logsTitle[0].id)
        } else {
          console.log("暂无更新日志")
        }
      })
    },
    // 获取某一个日志内容
    getLogItem(logId) {
      this.unfold = true;
      this.curLogId = logId;
      request({
        url: `/faq/faq/v1/getUpdateContentLog?logId=${logId}`,
        method: 'get'
      }).then(res => {
        if (res && res.data && res.data.updateLog) {
          this.curLog = res.data.updateLog;
        } else {
          console.log("获取当前更新日志失败")
        }
      })
    },
    handleUnfold(unfold) {
      this.unfold = unfold
    }
  }
}
</script>
<style scoped lang="scss">
.updatelog {
  height: 100%;
  overflow-y: auto;

  .log-content{
    width: 86%;
    max-width: 1500px;
    height: 100%;
    margin: auto;
  }

  ::v-deep {
    .v-note-wrapper {
      margin-top: 30px;
      border: none;
      z-index: 900;
      font-size: 14px;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.06);
      padding-bottom: 20px;
      color: #333;

      .v-note-panel .v-note-show .v-show-content {
        padding: 0;

        >* {
          padding-left: 30px;
          padding-right: 30px;
        }
      }

      h1,
      h2,
      h3 {
        margin: 0;
      }

      h1 {
        font-size: 24px;
        padding: 20px 0;
        border: none;
      }

      h2 {
        padding: 30px 0 22px 0;
        font-size: 22px;
        border-top: 1px solid #e9e9e9;
        border-bottom: none;
      }

      h3 {
        font-size: 18px;
        padding-bottom: 12px;
      }

      p {
        margin-bottom: 10px;
      }

      p+h2 {
        margin-top: 30px;
      }
    }
  }
}

.no-log {
  display: flex;
  justify-content: center;
  padding-top: 24px;
}
.no-log-info {
  font-size: 16px;
}

@media screen and (max-width: 824px) {
  .updatelog {
    .log-content {
      width: 100%;
    }

    ::v-deep {
      .v-note-wrapper {
        margin-top: 0;
        font-size: 12px;
        h1{
          font-size: 20px;
          padding: 16px 0;
        }
        h2{
          font-size: 18px;
          padding: 20px 0 10px 0;
        }
        h3{
          font-size: 16px;
        }
      }
    }
  }
}
</style>
